import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_16: FaireProductEntity = {
  token: "atc_fs_16",
  type: "product",
  name: "Chill-Out Tallow Cream",
  brandName: "Faurli",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1eb26bc40d36e3724628a86b6d1b03b962f0f9a9ac899e09ded6404a13f40385.webp",
  priceDollars: 28,
  msrpDollars: 56,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
